import { render, staticRenderFns } from "./IconedText.vue?vue&type=template&id=0290263e&scoped=true&"
import script from "./IconedText.vue?vue&type=script&lang=js&"
export * from "./IconedText.vue?vue&type=script&lang=js&"
import style0 from "./IconedText.vue?vue&type=style&index=0&id=0290263e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0290263e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
